import { useQuery } from "react-query";
import { getLeasedEquipmentModel } from "../../../../actions/CarrierAgreementMgmt/LeasedEquipment";

export const useGetLeasedEquipmentModel = () => {
  return useQuery("GetLeasedEquipmentModel", getLeasedEquipmentModel, {
    refetchOnWindowFocus: false,
  });
};
